// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-C":"SHP2C_shp2-detail-C__cO7xm"};